import { useContext } from "react";
import DialogContext from "../contexts/dialog-context";

export const useDialog = () => {
  const context = useContext(DialogContext);

  if (context === null) {
    throw new Error("useDialog must be used within a DialogContextProvider");
  }

  const { openDialog } = context;
  return { openDialog };
};
